// extracted by mini-css-extract-plugin
export default {"title":"DeleteRoleDialog_title__QQwlw","wrapButton":"DeleteRoleDialog_wrapButton__maIDa"};